import type { BugReportStatus } from '@/services/bug-report-service'

/** One theme variable per status, used as a dot and as a `color-mix` tint
 *  (`color-mix(in srgb, <var> N%, var(--window-background))`), so light, dark
 *  and custom themes all bring their own colours. */
export const BUG_REPORT_STATUS_COLORS: Record<BugReportStatus, string> = {
  open: 'var(--cdx-color-accent-alt)',
  in_progress: 'var(--cdx-color-accent)',
  waiting_for_reporter: 'var(--cdx-color-warning)',
  // "Geplant" (#1168, features only): decided, not started. Mixed from two
  // theme colours (a violet in the default themes) so it never reads as
  // "Offen" next to it on the board (#1171).
  planned: 'color-mix(in srgb, var(--cdx-color-accent) 60%, var(--cdx-color-danger))',
  resolved: 'var(--cdx-color-success)',
  closed: 'var(--text-secondary)',
}
